import catalog from './catalog';
import raEs from './ra';
import resourcesEs from './resources';
import tooltipsEs from './tooltips';

// Chaves nomeadas (ra.*, tooltips.*) + catálogo gettext (texto pt-BR → es) no mesmo nível.
const es = {
    ra: raEs,
    resources: resourcesEs,
    tooltips: tooltipsEs,
    ...catalog,
};

export default es;
